import React, { FC, useState, useContext } from "react";
import { Link } from "react-router-dom";

import { TrainingCourseSummary } from "@/features/training/model/Training/TrainingFolder";
import { EditTrainingCourse } from "@/features/training/ui";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import SchoolIcon from "@mui/icons-material/School";
import { Box, IconButton, Tooltip } from "@mui/material";
import { TreeItem } from "@mui/x-tree-view";
import { Language } from "@/model/Language/Language";

import { TranslationContext } from "@/app/providers";

import { GetLanguageValueAsString } from "@/app/application/Translate";


interface TrainingCourseItemProps {
	course: TrainingCourseSummary;
}

export const TrainingCourseItem: FC<TrainingCourseItemProps> = ({ course }) => {
	const translation: Language | null = useContext(TranslationContext);
	const [editCourseOpen, setEditCourseOpen] = useState(false);

	return (
		<>
			<TreeItem
				itemId={`course-${course.Id}`}
				label={
					<Box
						id={`tree-node-course-${course.Id}`}
						component="span"
						sx={{ display: "flex", alignItems: "center", width: "100%" }}
					>
						<Link
							to={`/training/courses/${course.Id}`}
							className="accordion-item-link accordion-item-link-action"
						>
							<SchoolIcon sx={{ mr: 1 }} />
							<p>{course.Name}</p>
						</Link>

						<Box className="accordion-item-action">
							<Tooltip title={GetLanguageValueAsString(translation, "Auto.Features.Training.Pages.TrainingTab.PanelLeft.Accordion.TrainingCourseItem.L37C23.EditCourse", "Edit course")} disableInteractive>
								<span>
									<IconButton
										size="small"
										onClick={(e) => {
											e.stopPropagation();
											setEditCourseOpen(true);
										}}
										sx={{
											opacity: 0.6,
											"&:hover": { opacity: 1 },
										}}
										aria-label={GetLanguageValueAsString(translation, "Auto.Features.Training.Pages.TrainingTab.PanelLeft.Accordion.TrainingCourseItem.L49C22.EditCourse", "Edit course")}
									>
										<EditOutlinedIcon fontSize="small" />
									</IconButton>
								</span>
							</Tooltip>
						</Box>
					</Box>
				}
			/>

			{/* Mount the modal OUTSIDE the label/TreeItem */}
			<EditTrainingCourse
				open={editCourseOpen}
				handleClose={() => setEditCourseOpen(false)}
				courseId={course.Id}
			/>
		</>
	);
};
